module.exports = __webpack_public_path__ + "media/images/flags/16/Togo-6fa7428b7491bcfb7b77eedb94101cbc.png";